import React, {Component} from 'react';
import {connect} from 'react-redux';
import {FadeLoader} from 'react-spinners';
import Modal from '../../components/Modal';
import {fetchDetalleFacturas} from '../../actions/Inmatriculacion';
import {fetchDocumentoDescargar} from '../../actions/FacturacionElectronica';
import ReactPaginate from 'react-paginate';
import moment from "moment/moment";
import doc from '../../images/xml-v2.png';
import pdf from '../../images/pdf-v2.png';
import saveAs from '../../utils/downloadFile';

const renderCeldaPdf = (item, that) => {
    if (item.numeroDocumento.startsWith("F") ||
        item.numeroDocumento.startsWith("B")) {
        return <div>
            {
                <a onClick={() => {
                    that.onClickDescargar({
                        'ruc': item.rucEmisor,
                        'tipoDocumento': item.tipoDocumentoSunat,
                        'serie': item.numeroDocumento.substring(0, 4),
                        'numero': item.numeroDocumento.substring(4, item.numeroDocumento.length),
                        'tipoArchivo': 'PDF'
                    });
                }}
                ><img alt='pdf' className='card-image' src={pdf}/></a>
            }

        </div>
    } else {
        return <div></div>
    }
};

const renderCeldaXml = (item, that) => {
    if (item.numeroDocumento.startsWith("F") ||
        item.numeroDocumento.startsWith("B")) {
        return <div>
            {
                <a onClick={() => {
                    that.onClickDescargar({
                        'ruc': item.rucEmisor,
                        'tipoDocumento': item.tipoDocumentoSunat,
                        'serie': item.numeroDocumento.substring(0, 4),
                        'numero': item.numeroDocumento.substring(4, item.numeroDocumento.length),
                        'tipoArchivo': 'XML'
                    });
                }}><img alt='xml' className='card-image' height={32} width={32} src={doc}/></a>
            }
        </div>
    } else {
        return <div></div>
    }
}
const renderTable = (registroReponse, that) => {
    if (registroReponse && registroReponse.resultList) {
        return registroReponse.resultList.map((item, index) => (
            <tr key={index}>
                <td>{item.tipoDocumento}</td>
                <td>{item.numeroDocumento}</td>
                <td>{(item.fechaEmision) ? moment(new Date(item.fechaEmision)).format("DD/MM/YYYY") : "-"}</td>
                <td>
                    {renderCeldaXml(item, that)}
                </td>
                <td>
                    {renderCeldaPdf(item, that)}
                </td>
            </tr>
        ));
    }
    return <tr>
        <td className='no-before' colSpan={7}>No hay resultados</td>
    </tr>;
};

class VerFacturas extends Component {
    constructor(props, context) {
        super(props, context);
        this.handleShow = this.handleShow.bind(this);
        this.handleHide = this.handleHide.bind(this);
        this.state = {
            muestraLoad: 'none',
            seleccionar: this.props.seleccionar,
            registroReponse: {itemList: null, numerodePaginas: 0},
        };
    }

    componentDidMount() {
        this.search();
    }

    search = () => {

        this.props.fetchDetalleFacturas(this.props.domain).then((result) => {
            if (result.payload.data.estadoTrama === '1') {
                this.setState({registroReponse: result.payload.data});
            }
        })
            .catch(() => {
                console.log("error al buscar situacionew")
            });
    };

    onClickDescargar(params) {
        this.setState({muestraLoad: 'block'});
        this.props.fetchDocumentoDescargar(params).then((result) => {
            if (result.payload.data.estado === 1) {
                const fileName = params.ruc + "-" + params.tipoDocumento + "-" + params.serie + "-" + params.numero + "." + params.tipoArchivo.toLowerCase();
                const contentType = 'application/pdf';
                const b64Data = result.payload.data.fileBase64;
                saveAs(b64Data, contentType, fileName);
                this.setState({muestraLoad: 'none'});
            } else {
                this.setState({muestraLoad: 'none'});
                this.props.showError(result.payload.data.mensaje)
            }
        }).catch(() => {
            this.setState({muestraLoad: 'none'});
            this.props.showError("Error interno en el servidor");
        });
    }


    handleShow() {
        this.setState({show: true});
    }

    handleHide() {
        this.setState({show: false});
    }

    render() {
        return (
            <div>
                <Modal idModal='ver-facturas' modalSize='modal-dialog' title='Detalle de Documentos'
                       closeModal={this.props.closeModal}
                       isOpen
                >
                    <div className='steps-container fdvNew-slides'>
                        <div>
                            <div>
                                <h4 className='mt-4 mb-2 labelInfo'>N° de Pedido: {this.props.domain.numPedidoVeh}</h4>
                                <br/>
                                <div className='tableWrapper hide-scroll table-180'>
                                    <table className='table table-hover'>
                                        <thead className='table-head'>
                                        <tr>
                                            <th>Tipo</th>
                                            <th>Nro Documento</th>
                                            <th>Fecha Emisión</th>
                                            <th></th>
                                            <th></th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            this.state.registroReponse.resultList
                                                ? renderTable(this.state.registroReponse, this)
                                                : <tr>
                                                    <td className='no-before' colSpan={7}><FadeLoader color={'#F8A14A'}
                                                                                                      loading/></td>
                                                </tr>
                                        }
                                        </tbody>
                                    </table>
                                </div>
                                {
                                    this.state.registroReponse &&
                                    <div
                                        className={this.state.registroReponse.numerodePaginas > 1 ? 'paginationWrapper' : 'hidden'}>
                                        <div className='row' style={{marginTop: '20px'}}>
                                            <div className='col-sm-6 pull-right'>
                                                <ReactPaginate
                                                    pageCount={this.state.registroReponse.numerodePaginas}
                                                    previousLabel='<<'
                                                    nextLabel='>>'
                                                    containerClassName='pagination pull-right'
                                                    pageClassName='pagination-item'
                                                    activeClassName='pagination-item--active'
                                                    pageLinkClassName='btn-clean pagination-item-btn'
                                                    breakClassName='break pagination-item'
                                                />
                                            </div>
                                        </div>
                                    </div>
                                }

                            </div>
                            <div className='modal-actions'>
                            </div>
                        </div>
                    </div>

                </Modal>
                <div className='modal extraFilter' role='dialog' data-backdrop='static'
                     style={{zIndex: '2000', display: this.state.muestraLoad}}>
                    <div className='modal-dialog modal-sm' role='document'>
                        <FadeLoader color={'#F8A14A'} loading/>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {registroReponse: state.registroReponse};
}


VerFacturas.defaultProps = {
    registroReponse: {itemList: [], numerodePaginas: 0},
    muestraLoad: 'none',
};

export default connect(mapStateToProps,
    {
        fetchDocumentoDescargar,
        fetchDetalleFacturas
    })(VerFacturas);



// WEBPACK FOOTER //
// ./src/pages/Inmatriculacion/verFacturas.js